export default __webpack_public_path__ + "static/media/icon_direct-download.3ffeb3ff.svg";